import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next/dist/client/script.js");
